export default __webpack_public_path__ + "media/zurb/img/legacy/reel/instructions-4-1b3cafc392c5a26dd748592e70c26608.png";